/**
 * TableSorter.ts
 */

import List from "list.js";
import { log } from '../../../dist/a11y-issue-logger';

const TableSorter = (() => {
  let options = {
    initElem: document.getElementsByClassName("js-sorter"),
  };

  function init() {
    if (options.initElem.length) {
      initSorter();

      if (EWDS_DEBUG) {
        console.log("[DEBUG] TableSorter : initialized");
      }
    }
  }

  function initSorter() {

    var options = {
      valueNames: ["sortName", "sortSubj", "sortDate"],
    };

    var MessageList = new List("js-table-sorter", options);

    var SortButtons = document.querySelectorAll(".sort-button");

    SortButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
      });
    });
  }
    

  return {
    init: init,
  };
})();

export default TableSorter;
